import { Globe, Mail, Phone } from "lucide-react"

const FooterLinks = () => (
  <>
    <div className="mt-8 pt-6 border-neutral-400 border-t">
      <p className="text-center">Thank you for your business</p>
    </div>
    <ul className="flex md:flex-row flex-col items-center justify-center text-xs pt-6 gap-6">
      <li>
        <a
          href="https://www.bankingbridge.com"
          target="_blank"
          rel="noreferrer"
          className="flex items-center gap-2"
        >
          <Globe size={16} />
          www.bankingbridge.com
        </a>
      </li>
      <li>
        <a href="tel:+8435143325" className="flex items-center gap-2">
          <Phone size={16} /> (843) 514-3325
        </a>
      </li>
      <li>
        <a
          href="mailto:support@bankingbridge.com"
          className="flex items-center gap-2"
        >
          <Mail size={16} />
          support@bankingbridge.com
        </a>
      </li>
    </ul>
  </>
)

export default FooterLinks
